/* THIS IS A GENERATED FILE. PLEASE DO NOT MODIFY!! */
import * as Types from '../../../../../../types/dashboard-core-gqlTypes.generated.d';

import { gql } from '@apollo/client';
export type BankInstitutionFragmentGQLType = (
  { __typename?: 'BankInstitution' }
  & Pick<Types.BankInstitutionGQLType, 'tellerInstitutionId' | 'plaidInstitutionId' | 'name' | 'institutionUrl' | 'primaryColor' | 'logoUrl' | 'bankInstitutionKey'>
);

export type BankDataProviderInstitutionAccountFieldsFragmentGQLType = (
  { __typename?: 'BankDataProviderInstitutionAccount' }
  & Pick<Types.BankDataProviderInstitutionAccountGQLType, 'dataProviderAccountId' | 'bankInstitutionId' | 'name' | 'mask' | 'type' | 'current' | 'available' | 'currency' | 'retrievedAt'>
);

export type BankDataProviderInstitutionFieldsFragmentGQLType = (
  { __typename?: 'BankDataProviderInstitution' }
  & Pick<Types.BankDataProviderInstitutionGQLType, 'bankInstitutionId' | 'name' | 'bankInstitutionKey' | 'dataProvider' | 'dataProviderInstitutionId' | 'itemId' | 'institutionUrl' | 'primaryColor' | 'logoUrl' | 'externalItemId' | 'needsUpdate'>
  & { bankAccounts: Array<(
    { __typename?: 'BankDataProviderInstitutionAccount' }
    & BankDataProviderInstitutionAccountFieldsFragmentGQLType
  )> }
);

export const BankInstitutionFragmentDocGQLType = gql`
    fragment BankInstitution on BankInstitution {
  tellerInstitutionId
  plaidInstitutionId
  name
  institutionUrl
  primaryColor
  logoUrl
  bankInstitutionKey
}
    `;
export const BankDataProviderInstitutionAccountFieldsFragmentDocGQLType = gql`
    fragment BankDataProviderInstitutionAccountFields on BankDataProviderInstitutionAccount {
  dataProviderAccountId
  bankInstitutionId
  name
  mask
  type
  current
  available
  currency
  retrievedAt
}
    `;
export const BankDataProviderInstitutionFieldsFragmentDocGQLType = gql`
    fragment BankDataProviderInstitutionFields on BankDataProviderInstitution {
  bankInstitutionId
  name
  bankInstitutionKey
  dataProvider
  dataProviderInstitutionId
  itemId
  institutionUrl
  primaryColor
  logoUrl
  externalItemId
  needsUpdate
  bankAccounts {
    ...BankDataProviderInstitutionAccountFields
  }
}
    ${BankDataProviderInstitutionAccountFieldsFragmentDocGQLType}`;